import React, { useState } from 'react';
import './SearchBar.css';

function SearchBar({ onSearch }) {
  const [searchInput, setSearchInput] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(searchInput);
  };

  const handleClear = () => {
    setSearchInput('');
    onSearch('');
  };

  return (
    <div className="search-bar">
      <form onSubmit={handleSubmit} className="search-form">
        <input
          type="text"
          placeholder="공고 제목, 내용, 구분으로 검색하세요"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          className="search-input"
        />
        <div className="search-buttons">
          <button type="submit" className="search-button">검색</button>
          {searchInput && (
            <button type="button" onClick={handleClear} className="clear-button">
              초기화
            </button>
          )}
        </div>
      </form>
    </div>
  );
}

export default SearchBar;